import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=0961fd68&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=0961fd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0961fd68",
  null
  
)

export default component.exports